import Vue from 'vue'
import PhotoToastNew from './index.vue'

const PopupBox = Vue.extend(PhotoToastNew)
let instance = null
PhotoToastNew.install = function (data) {
  if (data.action === 'close') {
    if (instance) {
      instance.visible = false
    }
    return
  }
  instance = new PopupBox({
    data
  }).$mount()
  document.body.appendChild(instance.$el)
  Vue.nextTick(() => {
    instance.visible = true
  })
}
export default PhotoToastNew
